import { useEffect } from "react";
import { useAuth, hasAuthParams } from "react-oidc-context";
import { useNavigate } from "react-router-dom";
import { loginActionMapper } from "src/constants/options";
import { PAGE } from "src/constants/page";
import { useAppSelector } from "src/redux/hooks";
import { PersistState } from "src/redux/reducers/PersistSlice";

// not displaying any UI, takes to keycloak login page

const Login = () => {
  const auth = useAuth();
  const navigate = useNavigate();
  const lang: any = useAppSelector(PersistState);
  const searchParams = new URLSearchParams(location?.search);
  let action_type: any = loginActionMapper.default;
  if (searchParams.get("l") && searchParams.get("a")) {
    action_type = loginActionMapper[searchParams.get("a") || "default"];
  }

  // automatically sign-in
  useEffect(() => {
    if (
      !hasAuthParams() &&
      !auth.isAuthenticated &&
      !auth.activeNavigator &&
      !auth.isLoading
    ) {
      //If user is not signed-in user is redirected to login page

      auth.signinRedirect({
        extraQueryParams: {
          action: action_type,
          ui_locales: lang?.language,
        },
      });
    } else if (auth.activeNavigator === "signinRedirect") {
      // TODO if we find any better approach to clear cookies it should be implimented.
      auth.signinRedirect({
        prompt: "login",
        extraQueryParams: {
          action: action_type,
          ui_locales: lang?.language,
        },
      });
    } else {
      //if user is valid naviagte to thier respective home pages
      if (searchParams.get("l") && searchParams.get("a")) {
        navigate(PAGE.GLOBAL_HOME + location?.search);
      } else {
        navigate(PAGE.GLOBAL_HOME);
      }
    }
  }, [
    auth.isAuthenticated,
    auth.activeNavigator,
    auth.isLoading,
    auth.signinRedirect,
  ]);

  return <></>;
};

export default Login;
